<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mb-4">
          <v-card-title primary-title>
            <h3 class="headline mb-0">Vendas</h3>
          </v-card-title>
          <v-card-text>
            <bar-chart-vendas :dados="vendas" />
            <sem-informacoes v-if="vendas.length == 0" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorRepresentante"
          :lista="listaVendasPorRepresentante"
          :totalQuantidade="totalQuantidadeVendasPorRepresentante"
          :totalValor="totalValorVendasPorRepresentante"
          :titulo="'Vendas por Representante'"
        />
      </v-flex>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorCliente"
          :lista="listaVendasPorCliente"
          :totalQuantidade="totalQuantidadeVendasPorCliente"
          :totalValor="totalValorVendasPorCliente"
          :titulo="'Vendas por Cliente'"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorEstado"
          :lista="listaVendasPorEstado"
          :totalQuantidade="totalQuantidadeVendasPorEstado"
          :totalValor="totalValorVendasPorEstado"
          :titulo="'Vendas por Estado'"
        />
      </v-flex>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorRegiao"
          :lista="listaVendasPorRegiao"
          :totalQuantidade="totalQuantidadeVendasPorRegiao"
          :totalValor="totalValorVendasPorRegiao"
          :titulo="'Vendas por Região'"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <grafico-produtos-mais-vendidos
          :dados="produtosMaisVendidos"
          :lista="listaProdutosMaisVendidos"
          :totalQuantidade="totalQuantidadeProdutosMaisVendidos"
          :totalValor="totalValorProdutosMaisVendidos"
          :titulo="'Produtos mais Vendidos'"
          :observacoes="
            'Este gráfico é um soma das quantidades dos produtos vendidos, não considerando descontos nos totais das vendas'
          "
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServiceGraficos from "@/services/graficos";
import BarChartVendas from "./BarChartVendas.vue";
import GraficoTemplate from "./GraficoTemplate.vue";
import GraficoProdutosMaisVendidos from "./GraficoProdutosMaisVendidos.vue";
import SemInformacoes from "./SemInformacoes.vue";

export default {
  name: "DashboardFornecedor",
  components: {
    BarChartVendas,
    GraficoTemplate,
    GraficoProdutosMaisVendidos,
    SemInformacoes,
  },
  data() {
    return {
      listaVendasPorFornecedor: [],
      listaVendasPorRepresentante: [],
      listaVendasPorCliente: [],
      listaVendasPorEstado: [],
      listaVendasPorRegiao: [],
      listaProdutosMaisVendidos: [],

      vendas: [],
      vendasPorRepresentante: [],
      vendasPorCliente: [],
      vendasPorEstado: [],
      vendasPorRegiao: [],
      produtosMaisVendidos: [],

      totalQuantidadeVendasPorFornecedor: 0,
      totalQuantidadeVendasPorRepresentante: 0,
      totalQuantidadeVendasPorCliente: 0,
      totalQuantidadeVendasPorEstado: 0,
      totalQuantidadeVendasPorRegiao: 0,
      totalQuantidadeProdutosMaisVendidos: 0,

      totalValorVendasPorFornecedor: 0,
      totalValorVendasPorRepresentante: 0,
      totalValorVendasPorCliente: 0,
      totalValorVendasPorEstado: 0,
      totalValorVendasPorRegiao: 0,
      totalValorProdutosMaisVendidos: 0,

      resposta: null,
      user: null,
      rodada: null,
    };
  },
  mounted() {
    this.user = this.$auth.user;
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.graficoVendas();
    this.graficoVendasPorRepresentante();
    this.graficoVendasPorCliente();
    this.graficoVendasPorEstado();
    this.graficoVendasPorRegiao();
    this.graficoProdutosMaisVendidos();
  },
  methods: {
    async graficoVendas() {
      this.resposta = await ServiceGraficos.vendasFor(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top12 = this.resposta.data.map((item, index) => {
        if (index <= 12) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.vendas = top12;
      });
    },

    async graficoVendasPorRepresentante() {
      this.resposta = await ServiceGraficos.vendasPorRepresentanteFor(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorRepresentante = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorRepresentante = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorRepresentante = this.resposta.data.somaValor;
        this.vendasPorRepresentante = top5;
      });
    },

    async graficoVendasPorCliente() {
      this.resposta = await ServiceGraficos.vendasPorClienteFor(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorCliente = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorCliente = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorCliente = this.resposta.data.somaValor;
        this.vendasPorCliente = top5;
      });
    },

    async graficoVendasPorEstado() {
      this.resposta = await ServiceGraficos.vendasPorEstadoFor(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorEstado = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorEstado = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorEstado = this.resposta.data.somaValor;
        this.vendasPorEstado = top5;
      });
    },

    async graficoVendasPorRegiao() {
      this.resposta = await ServiceGraficos.vendasPorRegiaoFor(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorRegiao = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorRegiao = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorRegiao = this.resposta.data.somaValor;
        this.vendasPorRegiao = top5;
      });
    },

    async graficoProdutosMaisVendidos() {
      this.resposta = await ServiceGraficos.produtosMaisVendidos(
        this.user.fornecedor_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaProdutosMaisVendidos = this.resposta.data.vendas;
        this.totalQuantidadeProdutosMaisVendidos = this.resposta.data.somaQuantidade;
        this.totalValorProdutosMaisVendidos = this.resposta.data.somaValor;
        this.produtosMaisVendidos = top5;
      });
    },
  },

  watch: {
    // 'dados': function(val, oldVal) {
    //   if (val) {
    //     console.log(this.dados)
    //   }
    // }
  },
};
</script>
